// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 24h sparkline column: smooth dual-color line + fill (see Market24hRangeChart.jsx) */
.m24h-spark {
  display: block;
  min-width: 72px;
  line-height: 0;
}

.m24h-spark__canvas {
  vertical-align: top;
}

/* 24h Price Range: dashed track, last-price dot, low / last / high hovers (no image) */
.m24h-range {
  width: 100%;
  /* Wider than the old 152px cap; column has more room after Market Cap was removed */
  max-width: min(280px, 100%);
  min-width: 0;
  margin: 0;
  text-align: left;
  box-sizing: border-box;
}

.market_page .chart_range .m24h-range,
.market_update_table .chart_range .m24h-range {
  width: 100%;
  max-width: min(280px, 100%);
}

.m24h-range__line-wrap {
  position: relative;
  height: 22px;
  margin: 0 0 6px 0;
}

.m24h-range__dashed {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  margin-top: -0.5px;
  height: 0;
  border: none;
  border-top: 1px dashed rgba(128, 136, 144, 0.85);
}

.m24h-range__dot {
  position: absolute;
  top: 50%;
  z-index: 1;
  width: 8px;
  height: 8px;
  margin-left: -4px;
  background: #fff;
  border: 1.5px solid #1e2329;
  border-radius: 50%;
  box-sizing: border-box;
  transform: translateY(-50%);
  pointer-events: none;
}

.m24h-range__zones {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  pointer-events: auto;
}

.m24h-range__zone {
  flex: 1 1 33.33%;
  position: relative;
  cursor: help;
  min-width: 0;
}

.m24h-range__pop {
  position: absolute;
  bottom: calc(100% + 6px);
  left: 50%;
  z-index: 5;
  transform: translateX(-50%);
  padding: 6px 10px;
  background: #2b2f36;
  color: #fff;
  font-size: 11px;
  line-height: 1.3;
  border-radius: 6px;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.12s ease, visibility 0.12s ease;
}

.m24h-range__zone:hover .m24h-range__pop,
.m24h-range__zone:focus-within .m24h-range__pop {
  opacity: 1;
  visibility: visible;
}

.m24h-range__pop span {
  display: block;
  opacity: 0.8;
  font-size: 10px;
  font-weight: 400;
}

.m24h-range__pop b {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
}

.m24h-range__pop::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -4px;
  border: 4px solid transparent;
  border-top-color: #2b2f36;
}

.m24h-range__labels {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 6px;
  font-size: 11px;
  line-height: 1.25;
  color: #1e2329;
}

.m24h-range__label {
  flex: 1 1;
  min-width: 0;
  text-align: left;
}

.m24h-range__label--mid {
  text-align: center;
  max-width: none;
  flex: 1 1;
}

.m24h-range__label--high {
  text-align: right;
  flex: 1 1;
}

.m24h-range__subl {
  display: block;
  font-size: 9px;
  color: #5c6674;
  margin-bottom: 1px;
}

.m24h-range__pr {
  display: block;
  font-weight: 600;
  font-size: 11px;
  color: #141820;
}

.m24h-range--empty .m24h-range__dot {
  left: 50% !important;
  opacity: 0.4;
}

body.dark_theme .m24h-range__labels,
.login_bg .m24h-range__labels {
  color: #b8c2cc;
}

body.dark_theme .m24h-range__subl,
.login_bg .m24h-range__subl {
  color: #6f7d8c;
}

body.dark_theme .m24h-range__pr,
.login_bg .m24h-range__pr {
  color: #9facbc;
}

body.dark_theme .m24h-range__dashed,
.login_bg .m24h-range__dashed {
  border-top-color: rgba(132, 142, 156, 0.55);
}

body.dark_theme .m24h-range__dot,
.login_bg .m24h-range__dot {
  background: #2b2f36;
  border-color: #eaecef;
}

/* Desktop table: range control spans the column; align body cell with the header text */
.market_page .market_update_sec .desktoptable .table > tbody > tr > td:nth-child(5) {
  text-align: left;
  vertical-align: middle;
}

.market_page .market_update_sec .desktoptable .table > tbody > tr > td:nth-child(5) .chart_range {
  display: block;
  width: 100%;
  max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/Market/market-24h-pricerange.css"],"names":[],"mappings":"AAAA,sFAAsF;AACtF;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uFAAuF;AACvF;EACE,WAAW;EACX,oFAAoF;EACpF,2BAA2B;EAC3B,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,qDAAqD;AACvD;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,SAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,wFAAwF;AACxF;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB","sourcesContent":["/* 24h sparkline column: smooth dual-color line + fill (see Market24hRangeChart.jsx) */\n.m24h-spark {\n  display: block;\n  min-width: 72px;\n  line-height: 0;\n}\n\n.m24h-spark__canvas {\n  vertical-align: top;\n}\n\n/* 24h Price Range: dashed track, last-price dot, low / last / high hovers (no image) */\n.m24h-range {\n  width: 100%;\n  /* Wider than the old 152px cap; column has more room after Market Cap was removed */\n  max-width: min(280px, 100%);\n  min-width: 0;\n  margin: 0;\n  text-align: left;\n  box-sizing: border-box;\n}\n\n.market_page .chart_range .m24h-range,\n.market_update_table .chart_range .m24h-range {\n  width: 100%;\n  max-width: min(280px, 100%);\n}\n\n.m24h-range__line-wrap {\n  position: relative;\n  height: 22px;\n  margin: 0 0 6px 0;\n}\n\n.m24h-range__dashed {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n  margin-top: -0.5px;\n  height: 0;\n  border: none;\n  border-top: 1px dashed rgba(128, 136, 144, 0.85);\n}\n\n.m24h-range__dot {\n  position: absolute;\n  top: 50%;\n  z-index: 1;\n  width: 8px;\n  height: 8px;\n  margin-left: -4px;\n  background: #fff;\n  border: 1.5px solid #1e2329;\n  border-radius: 50%;\n  box-sizing: border-box;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.m24h-range__zones {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  display: flex;\n  pointer-events: auto;\n}\n\n.m24h-range__zone {\n  flex: 1 1 33.33%;\n  position: relative;\n  cursor: help;\n  min-width: 0;\n}\n\n.m24h-range__pop {\n  position: absolute;\n  bottom: calc(100% + 6px);\n  left: 50%;\n  z-index: 5;\n  transform: translateX(-50%);\n  padding: 6px 10px;\n  background: #2b2f36;\n  color: #fff;\n  font-size: 11px;\n  line-height: 1.3;\n  border-radius: 6px;\n  white-space: nowrap;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transition: opacity 0.12s ease, visibility 0.12s ease;\n}\n\n.m24h-range__zone:hover .m24h-range__pop,\n.m24h-range__zone:focus-within .m24h-range__pop {\n  opacity: 1;\n  visibility: visible;\n}\n\n.m24h-range__pop span {\n  display: block;\n  opacity: 0.8;\n  font-size: 10px;\n  font-weight: 400;\n}\n\n.m24h-range__pop b {\n  display: block;\n  margin-top: 2px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.m24h-range__pop::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -4px;\n  border: 4px solid transparent;\n  border-top-color: #2b2f36;\n}\n\n.m24h-range__labels {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 6px;\n  font-size: 11px;\n  line-height: 1.25;\n  color: #1e2329;\n}\n\n.m24h-range__label {\n  flex: 1 1 0;\n  min-width: 0;\n  text-align: left;\n}\n\n.m24h-range__label--mid {\n  text-align: center;\n  max-width: none;\n  flex: 1 1 0;\n}\n\n.m24h-range__label--high {\n  text-align: right;\n  flex: 1 1 0;\n}\n\n.m24h-range__subl {\n  display: block;\n  font-size: 9px;\n  color: #5c6674;\n  margin-bottom: 1px;\n}\n\n.m24h-range__pr {\n  display: block;\n  font-weight: 600;\n  font-size: 11px;\n  color: #141820;\n}\n\n.m24h-range--empty .m24h-range__dot {\n  left: 50% !important;\n  opacity: 0.4;\n}\n\nbody.dark_theme .m24h-range__labels,\n.login_bg .m24h-range__labels {\n  color: #b8c2cc;\n}\n\nbody.dark_theme .m24h-range__subl,\n.login_bg .m24h-range__subl {\n  color: #6f7d8c;\n}\n\nbody.dark_theme .m24h-range__pr,\n.login_bg .m24h-range__pr {\n  color: #9facbc;\n}\n\nbody.dark_theme .m24h-range__dashed,\n.login_bg .m24h-range__dashed {\n  border-top-color: rgba(132, 142, 156, 0.55);\n}\n\nbody.dark_theme .m24h-range__dot,\n.login_bg .m24h-range__dot {\n  background: #2b2f36;\n  border-color: #eaecef;\n}\n\n/* Desktop table: range control spans the column; align body cell with the header text */\n.market_page .market_update_sec .desktoptable .table > tbody > tr > td:nth-child(5) {\n  text-align: left;\n  vertical-align: middle;\n}\n\n.market_page .market_update_sec .desktoptable .table > tbody > tr > td:nth-child(5) .chart_range {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
